import { render, staticRenderFns } from "./escortDetail.vue?vue&type=template&id=55ae0f87&scoped=true&"
import script from "./escortDetail.vue?vue&type=script&lang=js&"
export * from "./escortDetail.vue?vue&type=script&lang=js&"
import style0 from "./escortDetail.vue?vue&type=style&index=0&id=55ae0f87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ae0f87",
  null
  
)

export default component.exports